// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumb__root__cWwv1","heading":"Breadcrumb__heading__lYYaO"};